<div class="card sidebar">
  <mat-card class="sub-competency-sidebar">
  <div>
    <ul>
      <li *ngFor="let service of services ;let index = index" selected class="" [class.active]="selectedTabName === service.name" [ngClass]="{'selected-tab': selectedIndex === index}"
      (click)="openservicelines(service)">{{ service.name }}
      </li>
    </ul>
  </div>
</mat-card>
</div>
